import LocationIcon from "@/assets/icons/LocationIcon.svg?react";
import { CreatorLink } from "@/components/links/CreatorLink";
import { BaseCreatorDto } from "@/lib/lutely-api/gen/dtos";
import { cn } from "@/lib/utils";
import { Badge, Box } from "@radix-ui/themes";
import { formatLocationDisplay } from "@/lib/location/location-utils";

type ArtistCardProps = {
  creator: BaseCreatorDto;
  className?: string;
};

export default function ArtistCard({ creator, className }: ArtistCardProps) {
  if (!creator) return null;
  const locationString = formatLocationDisplay(creator.location);

  return (
    <Box className={cn("w-[200px]", className)}>
      <Box className="h-[200px] w-full">
        <CreatorLink
          creator={creator}
          className="block h-full w-full object-cover"
        >
          <Box
            className={cn(
              "bg-no-repeat bg-center bg-cover h-full w-full object-cover rounded-[50%]",
              {
                "bg-[url('/placeholders/album_art_placeholder.png')]":
                  !creator.profilePictureUrl,
              },
            )}
            style={
              creator.profilePictureUrl
                ? {
                    backgroundImage: `url(${creator.profilePictureUrl})`,
                  }
                : undefined
            }
          />
        </CreatorLink>
      </Box>
      <Box className="w-full text-center overflow-hidden truncate mt-[10px]">
        <CreatorLink
          creator={creator}
          className="text-[14px] block font-semibold text-text-primary truncate hover:underline"
        >
          {creator.stageName}
        </CreatorLink>
        {locationString.length > 0 && (
          <Box className="w-full truncate text-ellipsis mt-[7px]">
            <Badge
              variant="solid"
              radius="medium"
              size="2"
              className="text-[12px] font-semibold bg-background-quarternary text-text-secondary"
            >
              <LocationIcon />
              {locationString}
            </Badge>
          </Box>
        )}
      </Box>
    </Box>
  );
}
